import React from "react";
import { Stack } from "@mui/material";
import PresentationLinkTable from "../../components/presentation-links/PresentationLinkTable";

const PresentationLinks = () => {
    return (
        <Stack sx={{ padding: "16px" }}>
            <PresentationLinkTable />
        </Stack>
    );
};

export default PresentationLinks;
